export function isTexasZipCode(zip: string): boolean {
  if (!/^\d{5}$/.test(zip)) return false;
  const zipNum = parseInt(zip, 10);
  return (
    (zipNum >= 73301 && zipNum <= 73399) ||
    (zipNum >= 75001 && zipNum <= 79999) ||
    (zipNum >= 88510 && zipNum <= 88589)
  );
}
